import Vue from 'vue';
import VueRouter from 'vue-router';

import Home from '../page/Home';
// 管理平台
// 法務部
import BackStagePDISLogin from '../page/BackStage/PDIS/Login';
//首頁
import BackStageP102 from '../page/BackStage/PDIS/P102';
//A申報人基本資料維護
import BackStageA101 from '../page/BackStage/PDIS/A/A101';
import BackStageA103 from '../page/BackStage/PDIS/A/A103';
//B申報資料
import BackStageB101 from '../page/BackStage/PDIS/B/B101';
import BackStageB102 from '../page/BackStage/PDIS/B/B102';
import BackStageB103 from '../page/BackStage/PDIS/B/B103';
import BackStageB104 from '../page/BackStage/PDIS/B/B104';
import BackStageB105 from '../page/BackStage/PDIS/B/B105';
//D報表產製作業
import BackStageD101 from '../page/BackStage/PDIS/D/D101';
import BackStageD103 from '../page/BackStage/PDIS/D/D103';
import BackStageD106 from '../page/BackStage/PDIS/D/D106';
import BackStageD107 from '../page/BackStage/PDIS/D/D107';
import BackStageD108 from '../page/BackStage/PDIS/D/D108';
import BackStageD110 from '../page/BackStage/PDIS/D/D110';
import BackStageD111 from '../page/BackStage/PDIS/D/D111';
import BackStageD201 from '../page/BackStage/PDIS/D/D201';
import BackStageD202 from '../page/BackStage/PDIS/D/D202';
import BackStageD203 from '../page/BackStage/PDIS/D/D203';
import BackStageD204 from '../page/BackStage/PDIS/D/D204';
//F抽籤審核
import BackStageF101 from '../page/BackStage/PDIS/F/F101';
import BackStageF102 from '../page/BackStage/PDIS/F/F102';
import BackStageF103 from '../page/BackStage/PDIS/F/F103';
import BackStageF104 from '../page/BackStage/PDIS/F/F104';
import BackStageF105 from '../page/BackStage/PDIS/F/F105';
import BackStageF106 from '../page/BackStage/PDIS/F/F106';
import BackStageF201 from '../page/BackStage/PDIS/F/F201';
import BackStageF202 from '../page/BackStage/PDIS/F/F202';
import BackStageF203 from '../page/BackStage/PDIS/F/F203';
import BackStageF204 from '../page/BackStage/PDIS/F/F204';
//M授權管理
import BackStageM101 from '../page/BackStage/PDIS/M/M101';
import BackStageM102 from '../page/BackStage/PDIS/M/M102';
import BackStageM103 from '../page/BackStage/PDIS/M/M103';
import BackStageM104 from '../page/BackStage/PDIS/M/M104';
import BackStageM105 from '../page/BackStage/PDIS/M/M105';
import BackStageM106 from '../page/BackStage/PDIS/M/M106';
// S系統管理
import BackStageS101 from '../page/BackStage/PDIS/S/S101';
import BackStageS201 from '../page/BackStage/PDIS/S/S201';
import BackStageS202 from '../page/BackStage/PDIS/S/S202';
import BackStageS203 from '../page/BackStage/PDIS/S/S203';
import BackStageS301 from '../page/BackStage/PDIS/S/S301';
import BackStageS302 from '../page/BackStage/PDIS/S/S302';
import BackStageS303 from '../page/BackStage/PDIS/S/S303';
import BackStageS304 from '../page/BackStage/PDIS/S/S304';
import BackStageS305 from '../page/BackStage/PDIS/S/S305';
import BackStageS306 from '../page/BackStage/PDIS/S/S306';
import BackStageS401 from '../page/BackStage/PDIS/S/S401';
import BackStageS402 from '../page/BackStage/PDIS/S/S402';
import BackStageS404 from '../page/BackStage/PDIS/S/S404';
import BackStageS406 from '../page/BackStage/PDIS/S/S406';
import BackStageS601 from '../page/BackStage/PDIS/S/S601';
import BackStageS602 from '../page/BackStage/PDIS/S/S602';
import BackStageS603 from '../page/BackStage/PDIS/S/S603';
import BackStageS701 from '../page/BackStage/PDIS/S/S701';
import BackStageS702 from '../page/BackStage/PDIS/S/S702';
import BackStageS703 from '../page/BackStage/PDIS/S/S703';
// 監察院
import BackStageCYLogin from '../page/BackStage/CY/Login';
//P首頁
import BackStageCYP102 from '../page/BackStage/CY/P102';
//B申報資料
import BackStageCYB201 from '../page/BackStage/CY/B/B201';
import BackStageCYB202 from '../page/BackStage/CY/B/B202';
import BackStageCYB203 from '../page/BackStage/CY/B/B203';
import BackStageCYM104 from '../page/BackStage/CY/M/M104';
import BackStageCYM201 from '../page/BackStage/CY/M/M201';
import BackStageCYM205 from '../page/BackStage/CY/M/M205';
import BackStageCYS101 from '../page/BackStage/CY/S/S101';
import BackStageCYS201 from '../page/BackStage/CY/S/S201';
import BackStageCYS202 from '../page/BackStage/CY/S/S202';
import BackStageCYS203 from '../page/BackStage/CY/S/S203';
import BackStageCYS301 from '../page/BackStage/CY/S/S301';
import BackStageCYS302 from '../page/BackStage/CY/S/S302';
import BackStageCYS303 from '../page/BackStage/CY/S/S303';
import BackStageCYS306 from '../page/BackStage/CY/S/S306';
import BackStageCYS314 from '../page/BackStage/CY/S/S314';
import BackStageCYS315 from '../page/BackStage/CY/S/S315';
import BackStageCYS402 from '../page/BackStage/CY/S/S402';
import BackStageCYS406 from '../page/BackStage/CY/S/S406';
import BackStageCYS601 from '../page/BackStage/CY/S/S601';
import BackStageCYS602 from '../page/BackStage/CY/S/S602';
import BackStageCYS603 from '../page/BackStage/CY/S/S603';
import BackStageCYS701 from '../page/BackStage/CY/S/S701';
import BackStageCYS702 from '../page/BackStage/CY/S/S702';
import BackStageCYS703 from '../page/BackStage/CY/S/S703';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    //管理平台-法務部登入
    path: '/BackStage/PDIS/Login',
    name: 'PDISLogin',
    component :BackStagePDISLogin,
  },
  {
    //P102_首頁
    path: '/BackStage/PDIS/P102',
    name: 'P102',
    component :BackStageP102,
  },
  /*** A申報人基本資料 ***/
  {
    //A101_申報人基本資料維護
    path: '/BackStage/PDIS/A101',
    name: 'A101',
    component :BackStageA101,
  },
  {
    //A103_申報人資料整批移轉
    path: '/BackStage/PDIS/A103',
    name: 'A103',
    component :BackStageA103,
  },
  /*** B申報資料 ***/
  /** B1申報人申報資料 **/
  {
    //B101_申報資料明細查詢
    path: '/BackStage/PDIS/B101',
    name: 'B101',
    component :BackStageB101,
  },
  {
    //B102_申報資料紙本上傳維護
    path: '/BackStage/PDIS/B102',
    name: 'B102',
    component :BackStageB102,
  },
  {
    //B103_保險含括聲明查詢
    path: '/BackStage/PDIS/B103',
    name: 'B103',
    component :BackStageB103,
  },
  {
    //B104_歷年申報資料明細查詢
    path: '/BackStage/PDIS/B104',
    name: 'B104',
    component :BackStageB104,
  },
  {
    //B105_各機關申報狀態查詢
    path: '/BackStage/PDIS/B105',
    name: 'B105',
    component :BackStageB105,
  },
  /*** D報表產製作業 ***/
  /** D1各類報表產製作業 **/
  {
    //D101_應申報人員
    path: '/BackStage/PDIS/D101',
    name: 'D101',
    component :BackStageD101,
  },
  {
    //D103_N日後逾期申報人員表
    path: '/BackStage/PDIS/D103',
    name: 'D103',
    component :BackStageD103,
  },
  {
    //D106_公職人員抽籤名單
    path: '/BackStage/PDIS/D106',
    name: 'D106',
    component :BackStageD106,
  },
  {
    //D107_公職人員財產申報人數及抽查比例統計表
    path: '/BackStage/PDIS/D107',
    name: 'D107',
    component :BackStageD107,
  },
  {
    //D108_財產申報案件管理一覽表
    path: '/BackStage/PDIS/D108',
    name: 'D108',
    component :BackStageD108,
  },
  {
    //D110_自然人憑證使用人數統計(月報表)
    path: '/BackStage/PDIS/D110',
    name: 'D110',
    component :BackStageD110,
  },
  {
    //D111_授權狀況一覽表
    path: '/BackStage/PDIS/D111',
    name: 'D111',
    component :BackStageD111,
  },
  /** D2異常資料管理報表 **/
  {
    //D201_申報類別勾選錯誤名單
    path: '/BackStage/PDIS/D201',
    name: 'D201',
    component :BackStageD201,
  },
  {
    //D202_卸離職/解除代理(兼任)申報日與卸離職日不符名單
    path: '/BackStage/PDIS/D202',
    name: 'D202',
    component :BackStageD202,
  },
  {
    //D203_申報日非於申報期間名單
    path: '/BackStage/PDIS/D203',
    name: 'D203',
    component :BackStageD203,
  },
  {
    //D204_一年以上不須申報人員名單
    path: '/BackStage/PDIS/D204',
    name: 'D204',
    component :BackStageD204,
  },
  /*** F抽籤審核 ***/
  /** F1實質審查抽籤 **/
  {
    //F101_抽籤作業
    path: '/BackStage/PDIS/F101',
    name: 'F101',
    component :BackStageF101,
  },
  {
    //F102_中籤名單維護
    path: '/BackStage/PDIS/F102',
    name: 'F102',
    component :BackStageF102,
  },
  {
    //F103_抽籤歷程查詢
    path: '/BackStage/PDIS/F103',
    name: 'F103',
    component :BackStageF103,
  },
  {
    //F104_其他抽籤人員匯入
    path: '/BackStage/PDIS/F104',
    name: 'F104',
    component :BackStageF104,
  },
  {
    //F105_抽籤名單匯入
    path: '/BackStage/PDIS/F105',
    name: 'F105',
    component :BackStageF105,
  },
  {
    //F106_各年度抽籤名單查詢作業
    path: '/BackStage/PDIS/F106',
    name: 'F106',
    component :BackStageF106,
  },
  /** F2實質審核 **/
  {
    //F201_財產申報資料審核作業
    path: '/BackStage/PDIS/F201',
    name: 'F201',
    component :BackStageF201,
  },
  {
    //F202_前後年度申報財產比對
    path: '/BackStage/PDIS/F202',
    name: 'F202',
    component :BackStageF202,
  },
  {
    //F203_實質審核誤差值設定
    path: '/BackStage/PDIS/F203',
    name: 'F203',
    component :BackStageF203,
  },
  {
    //F204_財稅資料查詢(含所得及財產)
    path: '/BackStage/PDIS/F204',
    name: 'F204',
    component :BackStageF204,
  },
  /*** M授權管理 ***/
  {
    //M101_查調(授權)名單管理
    path: '/BackStage/PDIS/M101',
    name: 'M101',
    component :BackStageM101,
  },
  {
    //M102_查調(授權)名單彙整
    path: '/BackStage/PDIS/M102',
    name: 'M102',
    component :BackStageM102,
  },
  {
    //M103_查調(授權)名單匯入平臺
    path: '/BackStage/PDIS/M103',
    name: 'M103',
    component :BackStageM103,
  },
  {
    //M104_授權時段管理
    path: '/BackStage/PDIS/M104',
    name: 'M104',
    component :BackStageM104,
  },
  {
    //M105_授權查調財產資料查詢
    path: '/BackStage/PDIS/M105',
    name: 'M105',
    component :BackStageM105,
  },
  {
    //M106_取消持續授權
    path: '/BackStage/PDIS/M106',
    name: 'M106',
    component :BackStageM106,
  },
  /*** S系統管理 ***/
  /** S1代碼維護 **/
  {
    //S101_代碼維護
    path: '/BackStage/PDIS/S101',
    name: 'S101',
    component :BackStageS101,
  },
  /** S2系統功能表維護 **/
  {
    //S201_系統功能目錄階層維護
    path: '/BackStage/PDIS/S201',
    name: 'S201',
    component :BackStageS201,
  },
  {
    //S202_系統程式維護
    path: '/BackStage/PDIS/S202',
    name: 'S202',
    component :BackStageS202,
  },
  {
    //S203_群組維護
    path: '/BackStage/PDIS/S203',
    name: 'S203',
    component :BackStageS203,
  },
  /** S3使用者帳號密碼維護 **/
  {
    //S301_使用者帳號維護
    path: '/BackStage/PDIS/S301',
    name: 'S301',
    component :BackStageS301,
  },
  {
    //S302_使用者密碼變更
    path: '/BackStage/PDIS/S302',
    name: 'S302',
    component :BackStageS302,
  },
  {
    //S303_忘記密碼
    path: '/BackStage/PDIS/S303',
    name: 'S303',
    component :BackStageS303,
  },
  {
    //S304_服務機關資料維護
    path: '/BackStage/PDIS/S304',
    name: 'S304',
    component :BackStageS304,
  },
  {
    //S305_政風單位資料維護
    path: '/BackStage/PDIS/S305',
    name: 'S305',
    component :BackStageS305,
  },
  {
    //S306_密碼申請
    path: '/BackStage/PDIS/S306',
    name: 'S306',
    component :BackStageS306,
  },
  /** S4系統資訊維護 **/
  {
    //S401_年度假日管理
    path: '/BackStage/PDIS/S401',
    name: 'S401',
    component :BackStageS401,
  },
  {
    //S402_公告維護
    path: '/BackStage/PDIS/S402',
    name: 'S402',
    component :BackStageS402,
  },
  {
    //S404_電子郵件通知設定
    path: '/BackStage/PDIS/S404',
    name: 'S404',
    component :BackStageS404,
  },
  {
    //S406_常見問題維護
    path: '/BackStage/PDIS/S406',
    name: 'S406',
    component :BackStageS406,
  },
  /** S6系統記錄查詢 **/
  {
    //S601_公職人員財產申報系統使用記錄查詢
    path: '/BackStage/PDIS/S601',
    name: 'S601',
    component :BackStageS601,
  },
  {
    //S602_後台使用記錄查詢
    path: '/BackStage/PDIS/S602',
    name: 'S602',
    component :BackStageS602,
  },
  {
    //S603_跨平台介接記錄查詢
    path: '/BackStage/PDIS/S603',
    name: 'S603',
    component :BackStageS603,
  },
  {
    //S701_系統排程設定
    path: '/BackStage/PDIS/S701',
    name: 'S701',
    component :BackStageS701,
  },
  {
    //S702系統排程執行記錄查詢
    path: '/BackStage/PDIS/S702',
    name: 'S702',
    component :BackStageS702,
  },
  {
    //S703查調財產歸戶作業
    path: '/BackStage/PDIS/S703',
    name: 'S703',
    component :BackStageS703,
  },
  {
    //管理平台-監察院登入
    path: '/BackStage/CY/Login',
    name: 'CYLogin',
    component :BackStageCYLogin,
  },
  {
    //管理平台-監察院首頁
    path: '/BackStage/CY/P102',
    name: 'P102',
    component :BackStageCYP102,
  },
  {
    //管理平台-監察院B201_申報資料明細查詢
    path: '/BackStage/CY/B201',
    name: 'B201',
    component :BackStageCYB201,
  },
  {
    //管理平台-監察院B202_刪除申報表
    path: '/BackStage/CY/B202',
    name: 'B202',
    component :BackStageCYB202,
  },
  {
    //管理平台-監察院B203_保險含括聲明查詢
    path: '/BackStage/CY/B203',
    name: 'B203',
    component :BackStageCYB203,
  },
  {
    //管理平台-監察院M104_授權時段管理
    path: '/BackStage/CY/M104',
    name: 'M104',
    component :BackStageCYM104,
  },
  {
    //管理平台-監察院M201_匯出授權名單
    path: '/BackStage/CY/M201',
    name: 'M201',
    component :BackStageCYM201,
  },
  {
    //管理平台-監察院M205_授權查調財產資料查詢
    path: '/BackStage/CY/M205',
    name: 'M205',
    component :BackStageCYM205,
  },
  {
    //管理平台-監察院S101_代碼維護
    path: '/BackStage/CY/S101',
    name: 'S101',
    component :BackStageCYS101,
  },
  /** S2系統功能表維護 **/
  {
    //管理平台-監察院S201_系統功能目錄階層維護
    path: '/BackStage/CY/S201',
    name: 'S201',
    component :BackStageCYS201,
  },
  {
    //管理平台-監察院S202_系統程式維護
    path: '/BackStage/CY/S202',
    name: 'S202',
    component :BackStageCYS202,
  },
  {
    //管理平台-監察院S203_群組維護
    path: '/BackStage/CY/S203',
    name: 'S203',
    component :BackStageCYS203,
  },
  {
    //管理平台-監察院S301_使用者帳號維護
    path: '/BackStage/CY/S301',
    name: 'S301',
    component :BackStageCYS301,
  },
  {
    //管理平台-監察院S302_使用者密碼變更
    path: '/BackStage/CY/S302',
    name: 'S302',
    component :BackStageCYS302,
  },
  {
    //管理平台-監察院S303_忘記密碼
    path: '/BackStage/CY/S303',
    name: 'S303',
    component :BackStageCYS303,
  },
  {
    //管理平台-監察院S306_密碼申請
    path: '/BackStage/CY/S306',
    name: 'S306',
    component :BackStageCYS306,
  },
  {
    //管理平台-監察院S314_服務機關資料維護
    path: '/BackStage/CY/S314',
    name: 'S314',
    component :BackStageCYS314,
  },
  {
    //管理平台-監察院S315_帳號資料維護
    path: '/BackStage/CY/S315',
    name: 'S315',
    component :BackStageCYS315,
  },
  {
    //管理平台-監察院S402_公告維護
    path: '/BackStage/CY/S402',
    name: 'S402',
    component :BackStageCYS402,
  },
  {
    //管理平台-監察院S406_常見問題維護
    path: '/BackStage/CY/S406',
    name: 'S406',
    component :BackStageCYS406,
  },
  /** S6系統記錄查詢 **/
  {
    //管理平台-監察院S601_公職人員財產申報系統使用記錄查詢
    path: '/BackStage/CY/S601',
    name: 'S601',
    component :BackStageCYS601,
  },
  {
    //管理平台-監察院S602_後台使用記錄查詢
    path: '/BackStage/CY/S602',
    name: 'S602',
    component :BackStageCYS602,
  },
  {
    //管理平台-監察院S602_後台使用記錄查詢
    path: '/BackStage/CY/S603',
    name: 'S603',
    component :BackStageCYS603,
  },
  {
    //管理平台-監察院S701_系統排程設定
    path: '/BackStage/CY/S701',
    name: 'S701',
    component :BackStageCYS701,
  },
  {
    //管理平台-監察院S702_系統排程執行記錄查詢
    path: '/BackStage/CY/S702',
    name: 'S702',
    component :BackStageCYS702,
  },
  {
    //管理平台-監察院S703_系統排程執行查詢
    path: '/BackStage/CY/S703',
    name: 'S703',
    component :BackStageCYS703,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
